// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: var(--bg-primary);
  flex-direction: row;
  padding-bottom: var(--status-bar-height);
  position: relative;
}

.editor-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

.side-panel-wrapper { display: contents; }
.app-shell.panel-closed .side-panel-wrapper { display: none; }

@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .app-shell {
    flex-direction: column;
    padding-bottom: 56px;
  }
  .app-shell.mob-panel .editor-column { display: none; }
  .app-shell.mob-editor .side-panel-wrapper { display: none; }
  .app-shell.panel-closed.mob-panel .side-panel-wrapper { display: contents; }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/AppShell.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA,sBAAsB,iBAAiB,EAAE;AACzC,8CAA8C,aAAa,EAAE;;AAE7D;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA,sCAAsC,aAAa,EAAE;EACrD,4CAA4C,aAAa,EAAE;EAC3D,wDAAwD,iBAAiB,EAAE;AAC7E","sourcesContent":[".app-shell {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  background: var(--bg-primary);\n  flex-direction: row;\n  padding-bottom: var(--status-bar-height);\n  position: relative;\n}\n\n.editor-column {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.side-panel-wrapper { display: contents; }\n.app-shell.panel-closed .side-panel-wrapper { display: none; }\n\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .app-shell {\n    flex-direction: column;\n    padding-bottom: 56px;\n  }\n  .app-shell.mob-panel .editor-column { display: none; }\n  .app-shell.mob-editor .side-panel-wrapper { display: none; }\n  .app-shell.panel-closed.mob-panel .side-panel-wrapper { display: contents; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
